<mat-toolbar color="primary" class="top-navbar">
  <span class="title">Teacher Dashboard</span>
  <span class="spacer"></span>

  <button mat-icon-button>
    <mat-icon>notifications</mat-icon>
  </button>

  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>account_circle</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
	<span>My Account</span>
    <button mat-menu-item>Profile</button>
	<buton mat-menu-item>Settings</buton>
    <button mat-menu-item>Logout</button>
  </mat-menu>
</mat-toolbar>
